export const LightGalleryKeyString = "7324B923-889D-4F71-B289-C71B3B9584BE"